import push from '../push';

export default push;
